export const ADMIN = 'admin'
export const USER = 'user'

export const ENABLE_FUNCS = {
    CUSTOMER_WEBSITE: 'customer_website',
    CLIENT_SERVICE_FEE: 'client_service_fee',
    AFFORDABLE_HOUSE: 'affordable_house',
    PROPERTY_OWNER_MANAGE: 'property_owner_manage',
}
